import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SidebarComponent } from './core/layout/sidebar/sidebar.component';
import { HeaderComponent } from './core/layout/header/header.component';
import { SubNavComponent } from './core/layout/subnav/subnav.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatSidenavModule, SidebarComponent, HeaderComponent, SubNavComponent],
  template: `
    <mat-sidenav-container class="app-shell">
      @if (isCompact()) {
        <mat-sidenav
          mode="over"
          [opened]="sidenavOpen()"
          [fixedInViewport]="true"
          (closedStart)="sidenavOpen.set(false)"
        >
          <app-sidebar />
        </mat-sidenav>
      }
      <mat-sidenav-content class="app-content">
        <app-header (toggleSidebar)="sidenavOpen.set(!sidenavOpen())" [showHamburger]="isCompact()" />
        @if (!isCompact()) {
          <app-subnav />
        }
        <main>
          <router-outlet />
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [`
    .app-shell { height: 100vh; }
    .app-content { display: flex; flex-direction: column; height: 100%; }
    main { flex: 1; overflow-y: auto; }
  `],
})
export class AppComponent {
  private readonly bp = inject(BreakpointObserver);
  private readonly destroyRef = inject(DestroyRef);

  readonly isCompact = signal(false);
  readonly sidenavOpen = signal(false);

  constructor() {
    this.bp.observe('(max-width: 1023px)')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(state => {
        this.isCompact.set(state.matches);
        if (!state.matches) this.sidenavOpen.set(false);
      });
  }
}
